<template>
    <div class="app-container">
        <el-card class="tableInfo">
            <div slot="header" class="clearfix">
                <span style="font-size:20px">基础信息</span>
            </div>
            <el-col :span="8">
              <el-row class="rowItem">
                <el-col class="lable" :span="8">商户名称：</el-col>
                <el-col :span="14">
                    {{this.venueInfo.venueName}}
                </el-col>
              </el-row>
              <el-row class="rowItem">
                <el-col class="lable" :span="8">会员端平台名称：</el-col>
                <el-col :span="14">
                    {{this.venueInfo.chineseName}}
                </el-col>
              </el-row>
              <el-row class="rowItem">
                <el-col class="lable" :span="8">会员端平台简称：</el-col>
                <el-col :span="14">
                    {{this.venueInfo.englishName}}
                </el-col>
              </el-row>
              <el-row class="rowItem">
                  <el-col class="lable" :span="8">商户logo：</el-col>
                  <el-col :span="5">
                      <img  :src="'http://zlesp.zlydgy.cn:8091/images/'+this.venueInfo.logo" alt="">
                  </el-col>
                  <!-- <el-row style="marginTop:10px">
                  </el-row> -->
              </el-row>
              <el-row class="rowItem">
                <el-row class="lable" :span="3">商户介绍（首页展示）：</el-row>
                <el-row :span="20" style="height:250px;overflow-y:auto;" v-html="this.venueInfo.info">
                    <!-- {{this.venueInfo.info}} -->
                </el-row>
              </el-row>
              <el-row style="margin-top:50px">
                <el-col :span="10" :offset="2">
                  <el-button v-show="addType==1"
                    style="width:120px"
                    type="primary"
                    @click="edit(venueInfo)">
                    编辑
                  </el-button>
                  <el-button v-show="addType==2"
                    style="width:120px"
                    type="success"
                    @click="addBtn()">
                    新增
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="14" :offset="2">
              <el-row>
                <el-col :span="8">启动页</el-col>
                <el-col :span="8">会员端登录页</el-col>
                <el-col :span="8">员工端登录页</el-col>

              </el-row>
              <el-row>
                <el-col :span="8" class="yulan">
                  <img class="imgLogoyulan"  :src="'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.startimage" alt="">

                </el-col>
                <el-col :span="8" class="yulan" :offset="2">
                  <img class="imgLogoyulan"  :src="'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.memberloginimage" alt="">
                </el-col>
                <el-col :span="8" class="yulan" :offset="2">
                  <img class="imgLogoyulan"  :src="'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.employeeloginimage" alt="">
                </el-col>
              </el-row>
              <el-row style="margin-top:50px">
                <el-col :span="10" :offset="2">
                  <el-button
                    style="width:120px"
                    type="primary"
                    @click="edit2()">
                    编辑
                  </el-button>
                  <!-- <el-button
                    style="width:120px"
                    type="success"
                    @click="addBtn2()">
                    新增
                  </el-button> -->
                </el-col>
              </el-row>
            </el-col>
        </el-card>
        <el-dialog title="设置" :visible.sync="dialogVisible" width="1000px">
          <el-form :model="venueInfo" ref="venueInfo" :rules="rules" label-width="120px">
            <el-form-item label="商户名称" prop="venueName" v-if="type==1">
              <el-input class="w220" v-model="venueInfo.venueName" placeholder="请输入商户名称"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="会员端平台名称" v-if="type==1">
                  <el-input v-model="venueInfo.chineseName" type="text" placeholder="请输入会员端平台名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会员端平台简称" v-if="type==1">
                  <el-input v-model="venueInfo.englishName" type="text" placeholder="请输入会员端平台简称"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            
            <el-form-item label="商户简介" prop="info" v-if="type==1">
              <editor-bar v-model="venueInfo.info" :isClear="isClear"></editor-bar>
            </el-form-item>
            <el-form-item label="商户logo" ref="uploadElement" v-if="type==1">
                <el-upload
                  :class="{uploaderNone:hideUpload4}"
                  action="aa"
                  ref="upload4"
                  list-type="picture-card"
                  :auto-upload="false"
                  :http-request="uploadFile4"
                  :file-list="fileList4"
                  multiple
                  :limit="1"
                  :on-change="onChange4"
                  :on-remove="handleRemove4"
                  accept="image/png,image/gif,image/jpg,image/jpeg">
                  <!-- <i class="el-icon-plus"></i> -->
                  <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!-- *提示*：为了更好的用户体验，图片请提供150*150像素，文件大小不超过200kb。 -->
            </el-form-item>
            <el-form-item label="启动背景图" ref="uploadElement" v-if="type==2">
                <el-upload
                  :class="{uploaderNone:hideUpload}"
                  action="aa"
                  ref="upload"
                  list-type="picture-card"
                  :auto-upload="false"
                  :http-request="uploadFile"
                  :file-list="fileList"
                  multiple
                  :limit="1"
                  :on-change="onChange"
                  :on-remove="handleRemove"
                  accept="image/png,image/gif,image/jpg,image/jpeg">
                  <!-- <i class="el-icon-plus"></i> -->
                  <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!-- *提示*：为了更好的用户体验，图片请提供150*150像素，文件大小不超过200kb。 -->
            </el-form-item>
            <el-form-item label="会员登录背景图" ref="uploadElement" v-if="type==2">
              <el-upload
                :class="{uploaderNone:hideUpload2}"
                action="aa"
                ref="upload2"
                list-type="picture-card"
                :auto-upload="false"
                :http-request="uploadFile2"
                :file-list="fileList2"
                multiple
                :limit="1"
                :on-change="onChange2"
                :on-remove="handleRemove2"
                accept="image/png,image/gif,image/jpg,image/jpeg">
                <i class="el-icon-plus"></i>
              </el-upload>
               <!-- *提示*：为了更好的用户体验，图片请提供150*150像素，文件大小不超过500kb。 -->
            </el-form-item>
            <el-form-item label="员工登录背景图" ref="uploadElement" v-if="type==2">
              <el-upload
                :class="{uploaderNone:hideUpload3}"
                action="aa"
                ref="upload3"
                list-type="picture-card"
                :auto-upload="false"
                :http-request="uploadFile3"
                :file-list="fileList3"
                multiple
                :limit="1"
                :on-change="onChange3"
                :on-remove="handleRemove3"
                accept="image/png,image/gif,image/jpg,image/jpeg">
                <i class="el-icon-plus"></i>
              </el-upload>
               <!-- *提示*：为了更好的用户体验，图片请提供150*150像素，文件大小不超过500kb。 -->
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm()">取 消</el-button>
            <el-button type="primary" @click="submitForm('venueInfo')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { VueCropper }  from 'vue-cropper' 
import mainHead from "../../components/mainHead/mainHead";
import { construct, destruct } from '@aximario/json-tree';
import { getCustomerInfo, insertCustomerInfo, getLoginImagefo,updateLoginImagefo} from '../../api/configApi.js'
import EditorBar from '../../components/wangEnduit'
export default {
    props: {

    },
    data() {
      return {
        isClear: false,
        detail:"",
        nodata: true,
        dialogVisible:false,
        hideUpload: false,
        hideUpload2: false,
        hideUpload3: false,
        hideUpload4: false,
        loading: false,
        addType:1,
        type:1,
        venueInfo:{},
        fileList:[],//图片列表
        fileList2:[],
        fileList3:[],
        fileList4:[],
        imgList:[],
        trueList:[],
        formparams:{
          uploadFile:[],
          type:'banner',
          configInfo:[],
          imageId:[]
        },
        rules:{
          venueName:[{ required:true,message:'请输入商户名称',trigger:'blur' }],
          info:[{ required:true,message:'请输入商户说明',trigger:'blur' }],
        },
        formData: {}
      };
    },
    computed: {
    },
    created() {
    },
    mounted() {
      this.getConfigInfo()
      setTimeout(res=>{
        this.getLoginImagefo()
      },300)
    },
    watch: {

    },
    computed: {
    },
    methods: {
      getConfigInfo(){
        getCustomerInfo().then((res)=>{
          if(res.msg=='success'){
            if(res.data){
              this.venueInfo = res.data
              this.addType =1
            } else {
              this.addType = 2
            }
          }else {
            this.$message.error(res.data)
          }
        })
      },
      getLoginImagefo(){
        getLoginImagefo().then(res=>{
          if(res.msg=='success'){
            console.log(res)
            if(res.data){
              this.imgList = res.data
            }
          }else{
            this.$message.error(res.data)
          }
        })
      },
      showDialog() {
          this.dialogVisible = true
      },
      handleRemove(fileList) {
        this.hideUpload = fileList.length >= this.fileList.length;
      },
      handleRemove2(fileList) {
        this.hideUpload2 = fileList.length >= this.fileList2.length;
      },
      handleRemove3(fileList) {
        this.hideUpload3 = fileList.length >= this.fileList3.length;
      },
      handleRemove4(fileList) {
        this.hideUpload4 = fileList.length >= this.fileList4.length;
      },
      onChange(file, fileList){
        this.hideUpload = fileList.length <= this.fileList.length;
      },
      onChange2(file, fileList){
        this.hideUpload2 = fileList.length <= this.fileList2.length;
      },
      onChange3(file, fileList){
        this.hideUpload3 = fileList.length <= this.fileList3.length;
      },
      onChange4(file, fileList){
        this.hideUpload4 = fileList.length <= this.fileList4.length;
      },
      //编辑添加权限管理
      edit(info){
        this.addType =1
        this.type = 1
          // this.fileList=[]
          this.fileList4=[]
          this.fileList4.push({url:'http://zlesp.zlydgy.cn:8091/images/'+info.logo})
          if(this.fileList4){
            this.hideUpload4 = true
          } else {
            this.hideUpload4 = false
          }
          // if(this.fileList){
          //   this.hideUpload = true
          // } else {
          //   this.hideUpload = false
          // }
          this.dialogVisible = true
      },
      addBtn(){
          this.fileList4=[]
          // this.fileList2=[]
          this.dialogVisible = true
          this.addType =2
          this.type=1
      },
      edit2(){
        this.fileList=[]
        this.fileList2=[]
        this.fileList3=[]
        this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.startimage})
        this.fileList2.push({url:'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.memberloginimage})
        this.fileList3.push({url:'http://zlesp.zlydgy.cn:8091/images/'+this.imgList.employeeloginimage})
          if(this.fileList2){
            this.hideUpload2 = true
          } else {
            this.hideUpload2 = false
          }
          if(this.fileList){
            this.hideUpload = true
          } else {
            this.hideUpload = false
          }
          if(this.fileList3){
            this.hideUpload3 = true
          } else {
            this.hideUpload3 = false
          }
        this.dialogVisible = true
        this.type=2
      },
      addBtn2(){
        this.dialogVisible = true
        this.type=2
      },
      uploadFile(file){
        this.formData.append('startImage', file.file);
      },
      uploadFile2(file){
        this.formData.append('memberLoginImage', file.file);
      },
      uploadFile3(file){
        this.formData.append('employeeLoginImage', file.file);
      },
      uploadFile4(file){
        this.formData.append('logFile', file.file);
      },
      resetForm(){
        this.dialogVisible = false
      },
      async submitForm(venueInfo){
        this.$refs[venueInfo].validate(valid => {
          // if(this.type==2){
          //   console.log(this.$refs.upload.uploadFiles)
          //   if(this.$refs.upload.uploadFiles[0]){
          //     let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
          //     var re;
          //     re =  /^[A-Za-z0-9]+$/g;
          //     if (!re.test(nameARR[0])) {
          //       this.$message.error('上传图片名称只能是数字字母组合');
          //       this.fileList= []
          //       this.hideUpload = false
          //       return
          //     }
          //   }
          //   if(this.$refs.upload2.uploadFiles[0]){
          //     let nameARR2 = this.$refs.upload2.uploadFiles[0].name.split('.')
          //     var re;
          //     re =  /^[A-Za-z0-9]+$/g;
          //     if (!re.test(nameARR2[0])) {
          //       this.$message.error('上传图片名称只能是数字字母组合');
          //       this.fileList2= []
          //       this.hideUpload = false
          //       return
          //     }
          //   }  
          //   if(this.$refs.upload3.uploadFiles[0]){
          //     let nameARR3 = this.$refs.upload3.uploadFiles[0].name.split('.')
          //     var re;
          //     re =  /^[A-Za-z0-9]+$/g;
          //     if (!re.test(nameARR3[0])) {
          //       this.$message.error('上传图片名称只能是数字字母组合');
          //       this.fileList3= []
          //       this.hideUpload = false
          //       return
          //     }
          //   }
          // }else{
          //   if(this.$refs.upload4.uploadFiles[0]){
          //     let nameARR = this.$refs.upload4.uploadFiles[0].name.split('.')
          //     var re;
          //     re =  /^[A-Za-z0-9]+$/g;
          //     if (!re.test(nameARR[0])) {
          //       this.$message.error('上传图片名称只能是数字字母组合');
          //       this.fileList= []
          //       this.hideUpload = false
          //       return
          //     }
          //   }
            
          // }
          if (valid) {
            this.formData = new FormData()
            let config = {
              headers: {
                'Content-Type':'multipart/form-data',
                'token':sessionStorage.getItem('token')
              }
            }
            if(this.type==1){
              this.$refs.upload4.submit();
              this.formData.append('venueName', this.venueInfo.venueName);
              if(!this.venueInfo.chineseName){
                this.venueInfo.chineseName = ''
              }
              if(!this.venueInfo.englishName){
                this.venueInfo.englishName = ''
              }
              this.formData.append('chineseName', this.venueInfo.chineseName);
              this.formData.append('englishName', this.venueInfo.englishName);
              this.formData.append('logFile', this.venueInfo.logFile);
              this.formData.append('info', this.venueInfo.info);
              if(this.addType ==1){
                this.formData.append('id', this.venueInfo.id);
                this.$http.post('venue/updateCustomerInfo', this.formData, config).then((res)=>{
                  if(res.data.msg == 'success'){
                    this.dialogVisible = false
                    this.$message({
                      type:'success',
                      message:'修改成功'
                    })
                  }
                  this.getConfigInfo()
                })
              }else{
                this.$http.post('venue/insertCustomerInfo', this.formData, config).then((res)=>{
                  if(res.data.msg == 'success'){
                    this.dialogVisible = false
                    this.$message({
                      type:'success',
                      message:'新增成功'
                    })
                  }
                  this.getConfigInfo()
                })
              }
            }else{
              this.$refs.upload.submit();
              this.$refs.upload2.submit();
              this.$refs.upload3.submit();
              this.$http.post('venue/updateLoginImagefo', this.formData, config).then((res)=>{
                  console.log(res)
                  if(res.data.msg == 'success'){
                    this.dialogVisible = false
                    this.$message({
                      type:'success',
                      message:'修改成功'
                    })
                  }
                  this.getLoginImagefo()
                  // this.getConfigInfo()
                })
            }
           
          }
        })
      }
    },
    components: {
        mainHead,
        VueCropper,
        EditorBar
    },
};
</script>

<style lang="scss">
.app-container {
  position: relative;
  height: auto;
  .hide .el-upload--picture-card {
    display: none;
  }
  .tableInfo {
    height: 85vh;
    overflow-y: auto;
    padding-bottom: 30px;
    .clearfix{
      font-size: 20px;
       font-weight: bolder;
    }
    .rowItem{
        padding: 20px;
        border-bottom: 1px solid #f2f2f2; 
        .lable{
            font-size: 16px;
            font-weight:bolder; 
        }
        img{
            width: 100px;
            height: 100px;
            border: 1px solid #f2f2f2;
            border-radius: 5px;
        }
    }
  }
  .pageination {
    position: absolute;
    top: 82vh;
    left: 0;
    right: 0;
  }
}
.yulan{
  position: relative;
  width: 242px;
  height: 421px;
  position: relative;
  border: 1px solid #ccc;
  .imgyulan{
    width: 240px;
    height:100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 5;
  }
  .imgLogoyulan{
    position: absolute;
    width: 240px;
    height: 420px;
    background: #cccccc;
    
    // top: 38px;
    // left: 125px;
  }
}
</style>



// WEBPACK FOOTER //
// venue.vue?2be4606c